/**
 * Utility functions for displaying player information
 * Handles anonymous players and regular players
 */

export interface Player {
  id: number;
  name: string;
  preName: string;
  is_anonymous?: boolean;
}

/**
 * Get display name for a player, handling anonymous players
 */
export const getPlayerDisplayName = (player: Player | null | undefined): string => {
  if (!player) {
    return 'Unknown Player';
  }

  if (player.is_anonymous) {
    return 'Anonymous Player';
  }

  return `${player.preName} ${player.name}`.trim();
};

/**
 * Get short display name for a player (first name only)
 */
export const getPlayerShortName = (player: Player | null | undefined): string => {
  if (!player) {
    return 'Unknown';
  }

  if (player.is_anonymous) {
    return 'Anonymous';
  }

  return player.preName || player.name || 'Unknown';
};

/**
 * Check if a player is anonymous
 */
export const isAnonymousPlayer = (player: Player | null | undefined): boolean => {
  return player?.is_anonymous === true;
};

/**
 * Get CSS class for player name display
 */
export const getPlayerNameClass = (player: Player | null | undefined): string => {
  if (isAnonymousPlayer(player)) {
    return 'anonymous-player';
  }
  return 'regular-player';
};
